import { type RouteRecordRaw } from 'vue-router'

export const AttendeeRouter: RouteRecordRaw[] = [
  {
    path: '/attendees',
    component: async () => import('./AttendeeList.vue'),
  },
]
